






























































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue,Prop, Watch } from 'vue-property-decorator';
import { TbShopAccount, TbSettingsPad, TbShop } from '@/http';
import { NumberKeyboard } from "@/components";
import { Toast } from 'vant';
import QRCode from 'qrcodejs2'
import newLodop from "@/common/util/newlodop";
import {PrintEvent1, PrintEvent2} from "@/common/util/prints";
import JsBarcode from 'jsbarcode';
const { userAgent } = navigator;
const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('android') > -1 || userAgent.indexOf('Adr') > -1;; // android终端
@Component({
    components: {
        NumberKeyboard
    },
})
export default class xpInfo extends Vue {
    @Prop({
        default:1
    })
    activeitem:Number;
    public $refs: {
    };
    userInfo = {};
    shopInfo: any = {};
    //小票打印机名称
    receiptPrinterName = "";
    // 1收银小票 2充值小票
    padSetInfo: any = {
        // id:"",
        // type:null,
        settingContent: {
            businessHours: {
                isSelect: true,
                value: "",
            },
            cashier: {
                isSelect: true,
                value: "",
            },
            contactInfo: {
                isSelect: true,
                value: "",
            },
            currency: {
                isSelect: true,
                value: "",
            },
            dateTime: {
                isSelect: true,
                value: "",
            },
            goodsName: {
                isSelect: true,
                value: "",
            },
            member: {
                isSelect: true,
                value: "",
            },
            orderCode: {
                isSelect: true,
                value: "",
            },
            orderNumber: {
                isSelect: true,
                value: "",
            },
            payInfo: {
                isSelect: true,
                value: "",
            },
            qrCode: {
                isSelect: true,
                value: "",
            },
            shopInfo: {
                isSelect: true,
                value: "",
            },
            shopName: {
                isSelect: true,
                value: "",
            },
            remark: {
                isSelect: true,
                value: "",
            },
            welcomeMessage: {
                isSelect: true,
                value: "",
            },
            putNum: null,
            isPut: false,

        }
    };
    orderInfo = {
        //   订单Id
        id: "",
        // 订单编号
        orderNo: 'SY123456',
        // 店铺ID
        shopId: '',
        // 订单状态
        // 0 = None，缺省值
        // 1 = Wait，待支付
        // 2 = Success，支付成功
        // 3 = Failed，支付失败
        // 4 = Closed，已关闭
        orderStatus: 0,
        // 下单时间
        orderDate: '2023-09-28 12:30:45',
        // 会员Id
        memberId: '6666',
        // 会员姓名
        memberName: '',
        // 会员等级名称
        gradeName: '',
        // 会员手机号
        memberPhone: '19768298698',
        // 商品数量
        num: 4,
        // 商品总价
        goodsPrice: 458,

        // 支付方式
        // 0 = None，缺省值
        // 1 = MemberCard，会员卡
        // 2 = Cash，现金
        // 3 = Wechat，微信
        // 4 = AliPay，支付宝
        // 5 = Cash_Card_WeChat，现金+会员卡+微信
        // 6 = Cash_Card_Alipay，现金+会员卡+支付宝
        // 7 = Cash_WeChat，现金+微信
        // 8 = Cash_Alipay，现金+支付宝
        // 9 = Card_WeChat，会员卡+微信
        // 10 = Card_Alipay，会员卡+支付宝
        // 11 = Cash_Card，现金+会员卡
        paymentMethod: 2,
        // 支付类型
        // 0 = None，缺省值
        // 1 = WholeOrder，整单支付
        // 2 = Compose，组合支付
        paymentType: 0,
        // 整单折扣
        orderDiscount: 0.8,
        // 整单折扣优惠金额
        orderDiscountPrice: 20,
        // 会员折扣
        memberDiscount: 7.8,
        // 会员积分抵扣金额
        pointDeduction: 0,
        // 使用会员积分
        useIntegral: 0,
        // 总折扣额(元)
        totalDiscountPrice: 0,
        // 应收款
        receivables: 458,
        // 实收款
        actualPayment: 0,
        // 抹零
        erasePrice: 0,
        // 抹零方式
        // 0 = None，缺省值
        // 1 = Yuan，抹零到元
        // 2 = Jiao，抹零到角
        roundType: 0,
        // 合计(折后总价)
        totalAmount: 458,
        // 商品折扣优惠
        orderGoodsDiscount: 99,
        // 会员折扣优惠
        orderMemberDiscount: 0,
        // 找零
        giveChange: 20,
        // 现金支付金额
        cashPart: 458,
        // 会员卡支付金额
        cardPart: 100,
        // 微信支付金额
        weChatPart: 0,
        // 支付宝支付金额
        alipayPart: 0,
        // 订单类型
        // 0 = None，缺省值
        // 1 = Sales，销售订单
        // 2 = Return，退货订单
        orderType: 1,
        // 收银员id
        cashierId: '',
        // 收银员
        cashier: '张三',
        // 收银员员工号
        cashierNo: '22009',
        // 创建时间
        createTime: '',
        // 是否删除
        isDelete: false,
        // 变动积分
        changeIntegral: 100,
        // 是否整单折扣
        isWholeOrderDiscount: true,
        // 优惠券名称
        couponName: "此处显示该订单使用的优惠券名称",
        // 优惠券优惠金额
        couponPrice: 0,
        // 消费完剩余余额
        leftBalance: 99012,
        // 消费完剩余积分
        leftIntegral: 9019,
        // 消费完本次积分
        leftIntegral1: 1000,
        // 会员卡退回金额
        cardPrice: null,
        // 线下退回金额
        offlinePrice: null,
        // 实退金额
        returnPrice: null,
        // 商品成本
        costPrice: null,
        // 销售利润
        profit: null,
        // 销售利润率
        profitRate: null,
        // 赠品优惠金额
        giftDiscountPrice: null,
        // 赠品数量
        giftNum: null,
        // 赠品总额
        giftAmount: null,
        remarks:'此处显示订单的整单备注信息此处显示订单的整单备注信息此处显示订单的整单备注信息',

        // 订单子项
        items: [
            {

                articleNo: "230309342423301291",
                // 商品名称
                name: "商品名称长点效果韩式",
                // 商品分类
                goodsClassName: "",
                // 售价
                sellingPrice: 199,
                // 是否参与打折
                isDiscount: true,
                // 是否参与会员打折
                isMemberDiscount: false,
                // 商品折扣价
                discountPrice: 99,
                // 商品折扣
                goodDiscount: null,
                // 商品本身优惠(商品本身折扣+会员折扣)
                goodDiscountPrice: 99,
                // 规格名称
                goodsSpecsName: "规格值1/规格值2/规格值3",
                /**数量 */
                num: 1,
                // 最终总售价
                totalPrice: 199,
                goodsDiscount: 100,
                memberDiscount: 0,
                isCoupon: true,

            }, {

                articleNo: "230309342423301291",
                // 商品名称
                name: "商品名称长点效果韩式",
                // 商品分类
                goodsClassName: "",
                // 售价
                sellingPrice: 199,
                // 是否参与打折
                isDiscount: false,
                // 是否参与会员打折
                isMemberDiscount: false,
                // 商品折扣价
                discountPrice: 99,
                // 商品折扣
                goodDiscount: null,
                // 商品本身优惠(商品本身折扣+会员折扣)
                goodDiscountPrice: 99,
                // 规格名称
                goodsSpecsName: "规格值1/规格值2/规格值3",
                /**数量 */
                num: 1,
                // 最终总售价
                totalPrice: 199,
                goodsDiscount: 0,
                memberDiscount: 0,
                isCoupon: false,
            },]
    }
    checked = true;
    concatName = "";
    concatPhone = "";

    isEdit1 = false;
    isLoading1 = false;

    //二维码
    QRCode = null
    qrcode = null
    QRCode1 = null
    qrcode1 = null

    dateShow = false;
    startTime = "";
    endTime = "";

    czstartTime = "";
    czendTime = "";

    isPrintLoading = false;

    //货币下拉框
    showHbPopover = false;
    option1 = [{ label: '人民币￥', value: '¥' }, { label: '美元$', value: '＄' }, { label: '港币HK$', value: 'HK＄' }, { label: '澳门币MOP$', value: 'MOP＄' }, { label: '令吉RM', value: 'RM' },{label:'阿曼OMR',value:'OMR'},{label:'泰铢THB',value:'THB'},{label:'无货币符号',value:''}];

    //充值小票相关数据
    czpadSetInfo: any = {
        // id:"",
        // type:null,
        settingContent: {
            businessHours: {
                isSelect: true,
                value: "",
            },
            cashier: {
                isSelect: true,
                value: "",
            },
            contactInfo: {
                isSelect: true,
                value: "",
            },
            currency: {
                isSelect: true,
                value: "",
            },
            dateTime: {
                isSelect: true,
                value: "",
            },
            goodsName: {
                isSelect: true,
                value: "",
            },
            member: {
                isSelect: true,
                value: "",
            },
            orderCode: {
                isSelect: true,
                value: "",
            },
            orderNumber: {
                isSelect: true,
                value: "",
            },
            payInfo: {
                isSelect: true,
                value: "",
            },
            qrCode: {
                isSelect: true,
                value: "",
            },
            shopInfo: {
                isSelect: true,
                value: "",
            },
            shopName: {
                isSelect: true,
                value: "",
            },
            welcomeMessage: {
                isSelect: true,
                value: "",
            },
            putNum: null,
            isPut: false,

        }
    };
    czorderInfo = {
        //   订单Id
        id: "",
        // 订单编号
        orderNo: 'SY123456',
        // 店铺ID
        shopId: '',
        // 充值时间
        orderDate: '2023-09-28 12:30:45',
        // 会员Id
        memberId: '6666',
        // 会员姓名
        memberName: '',
        // 会员等级名称
        gradeName: '',
        // 会员手机号
        memberPhone: '19768298698',
        // 支付方式
        // 0 = None，缺省值
        // 2 = Cash，现金
        // 3 = Wechat，微信
        // 4 = AliPay，支付宝
        paymentMethod: 2,
        //收款金额
        receivedAmount: 500,
        // 找零
        giveChange: 20,
        // 收银员id
        cashierId: '',
        // 收银员
        cashierName: '张三',
        //充前金额
        originalAmount: 100,
        //充值金额
        rechargeAmount: 500,
        //赠送金额
        giftAmount: 50,
        //赠送积分
        giftIntegral: 100,
        //现有金额
        currentAmount: 650,
        //现有积分
        currentIntegral: 1200,
        address: '此处显示店铺中的详细地址',
    }
    czchecked = true;
    //打印机设备名称
    deviceList = [];

    created() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
        this.czorderInfo.shopId = this.userInfo['shopId'];
        this.orderInfo.shopId = this.userInfo['shopId'];
    }

    async mounted() {
   
        this.shopInfo = await TbShop.GetTbShopById({ id: this.userInfo['shopId'] });
        // if (localStorage.getItem('receiptPrinterName') && localStorage.getItem('receiptPrinterName') != 'null') {
        //     this.receiptPrinterName = localStorage.getItem('receiptPrinterName');
        // }
        this.receiptPrinterName = 'HPRT D25BT(ESC)'

        this.init();
        


    }
    activated() {

        // if (localStorage.getItem('receiptPrinterName')) {
        //     this.receiptPrinterName = localStorage.getItem('receiptPrinterName');
        // }
        this.receiptPrinterName = 'HPRT D25BT(ESC)'


    }
    /**获取货币符号展示 */
    get getChoiceHb() {
        let str = ""
        str = this.option1.findIndex(v => v.value == this.padSetInfo.settingContent.currency.value) > -1 ? this.option1.find(v => v.value == this.padSetInfo.settingContent.currency.value).label : '';
        return str;
    }
    /**充值获取货币符号展示 */
    get czgetChoiceHb() {
        let str = ""
        str = this.option1.findIndex(v => v.value == this.czpadSetInfo.settingContent.currency.value) > -1 ? this.option1.find(v => v.value == this.czpadSetInfo.settingContent.currency.value).label : '';
        return str;
    }


    openBlue() {
        this.deviceList = [];
        this.searchForBluetooth();
        this.$router.push(`/pad/setting/chooseBlue?name=xp`);
    }
    changeItem(val) {
        this.activeitem = val;
        this.init();
    }

    async init() {
        await this.clearQRCode();
        let res = null;
        if (this.activeitem == 1) {
            res = await TbSettingsPad.GetTbSettings({
                settingtype: 5
            });
            res.settingContent.contactInfo = res.settingContent.contactInfo ? res.settingContent.contactInfo : {
                index: 0,
                isSelect: false,
                value: ""
            }
            res.settingContent.qrCode = res.settingContent.qrCode ? res.settingContent.qrCode : {
                index: 0,
                isSelect: false,
                value: ""
            }
            res.settingContent.remark = res.settingContent.remark ? res.settingContent.remark : {
                index: 0,
                isSelect: true,
                value: ''
            };
            res.settingContent.receiptRemark=res.settingContent.receiptRemark?res.settingContent.receiptRemark:{
                index:0,
                isSelect:false,
                value:''
            };
            this.padSetInfo = res;

            if (this.padSetInfo.settingContent.contactInfo && this.padSetInfo.settingContent.contactInfo.isSelect && this.padSetInfo.settingContent.contactInfo.value) {
                let arr = this.padSetInfo.settingContent.contactInfo.value ? this.padSetInfo.settingContent.contactInfo.value.split(':') : [];
                if (arr.length > 0) {
                    this.concatName = arr[0]
                }
                if (arr.length >= 1) {
                    this.concatName = arr[0]
                    this.concatPhone = arr[1]
                }
            }
            if (this.padSetInfo.settingContent.shopName) {
                this.padSetInfo.settingContent.shopName.value = this.padSetInfo.settingContent.shopName.value ? this.padSetInfo.settingContent.shopName.value : this.shopInfo['shopName'];
            }
            console.log('this.padSetInfo', this.padSetInfo);
            let url = window.location.host.indexOf('test') > -1 ? `https://posm.hftopos.com/vipMpTest?shopId=${this.userInfo['shopId']}` : `https://posm.hftopos.com/vipMp?shopId=${this.userInfo['shopId']}`;
            console.log('url', url);

            this.$nextTick(() => {
                this.getEwm(url);
                // this.getEwm1(url);
            })
        } else {
            res = await TbSettingsPad.GetTbSettings({ settingtype: 6 });
            res.settingContent.businessHours = res.settingContent.businessHours ? res.settingContent.businessHours : {
                index: 0,
                isSelect: false,
                value: ''
            };
            res.settingContent.currency = res.settingContent.currency ? res.settingContent.currency : {
                index: 0,
                isSelect: false,
                value: ''
            };
            res.settingContent.dateTime = res.settingContent.dateTime ? res.settingContent.dateTime : {
                index: 0,
                isSelect: false,
                value: ''
            };
            res.settingContent.member = res.settingContent.member ? res.settingContent.member : {
                index: 0,
                isSelect: false,
                value: ''
            };
            res.settingContent.orderNumber = res.settingContent.orderNumber ? res.settingContent.orderNumber : {
                index: 0,
                isSelect: false,
                value: ''
            };
            res.settingContent.payInfo = res.settingContent.payInfo ? res.settingContent.payInfo : {
                index: 0,
                isSelect: false,
                value: ''
            };
            res.settingContent.shopName = res.settingContent.shopName ? res.settingContent.shopName : {
                index: 0,
                isSelect: false,
                value: ''
            };
            res.settingContent.welcomeMessage = res.settingContent.welcomeMessage ? res.settingContent.welcomeMessage : {
                index: 0,
                isSelect: false,
                value: ''
            };
            this.czpadSetInfo = res;
            console.log('this.czpadSetInfo', this.czpadSetInfo);
            if (this.czpadSetInfo.settingContent.shopName) {
                this.czpadSetInfo.settingContent.shopName.value = this.czpadSetInfo.settingContent.shopName.value ? this.czpadSetInfo.settingContent.shopName.value : this.shopInfo['shopName'];
            }
        }
        console.log('resresres', res);
    }
    //获取二维码
    getEwm(val) {
        console.log('getEwm');
        if (this.qrcode) {
            this.qrcode.clear(); // 清除当前二维码
        } else {

            let qrcode = new QRCode(document.getElementById("SetQRCode"), {
                text: val,//二维码中的内容
                width: 150,
                height: 150,
                colorDark: "#000",//二维码颜色
                correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
            })
            this.qrcode = qrcode;
        }
        // let childs = document.getElementById("SetQRCode").childNodes;
        // for(let i = childs.length -2 ; i>=0 ; i--){
        //     document.getElementById("SetQRCode").removeChild(childs[i]);
        // }
    }
    clearQRCode() {
        var qrcodeContainer = document.getElementById("SetQRCode");
        if (qrcodeContainer) {
            this.qrcode = null;
            while (qrcodeContainer.hasChildNodes()) { // 清空所有子节点
                qrcodeContainer.removeChild(qrcodeContainer.lastChild);
            }
        }
    }
    getEwm1(val) {
        let qrCode = val;
        this.QRCode1 = qrCode;
        let qrcodeDiv = document.getElementById("SetQRCode1")
        let qrcode = new QRCode(qrcodeDiv, {
            text: this.QRCode1,//二维码中的内容
            width: 150,
            height: 150,
            colorDark: "#000",//二维码颜色
            correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
        })
        this.qrcode1 = qrcode;
        let childs = document.getElementById("SetQRCode1").childNodes;
        for (let i = childs.length - 2; i >= 0; i--) {
            document.getElementById("SetQRCode1").removeChild(childs[i]);
        }
    }
    finishNum(val, type) {
        switch (type) {
            case 1:
                this.padSetInfo.settingContent.putNum = val;
                break;
            case 2:
                this.czpadSetInfo.settingContent.putNum = val;
                break;
            default:
                break;
        }
    }
    changeRadio(val, type) {
        if (!this.isEdit1) return;
        switch (type) {
            case 1:
                this.padSetInfo.settingContent.isPut = val;
                break;
            case 2:
                this.padSetInfo.settingContent.shopName.isSelect = val;
                if (val) {
                    this.padSetInfo.settingContent.shopName.value = this.shopInfo['shopName'];
                } else {
                    this.padSetInfo.settingContent.shopName.value = "";
                }
                break;
            case 3:
                this.padSetInfo.settingContent.member.isSelect = val;
                break;
            case 4:
                this.padSetInfo.settingContent.payInfo.isSelect = val;
                break;
            case 5:
                this.padSetInfo.settingContent.orderCode.isSelect = val;
                break;
            case 6:
                this.padSetInfo.settingContent.contactInfo.isSelect = val;

                if (val) {
                    this.concatName = this.shopInfo.name;
                    this.concatPhone = this.shopInfo.phone;
                }
                break;
            case 7:
                this.padSetInfo.settingContent.qrCode.isSelect = val;
                this.clearQRCode();
                this.$nextTick(() => {
                    let url = window.location.host.indexOf('test') > -1 ? `https://posm.hftopos.com/vipMpTest?shopId=${this.userInfo['shopId']}` : `https://posm.hftopos.com/vipMp?shopId=${this.userInfo['shopId']}`;
                    this.getEwm(url);
                })
                break;
            case 8:
                this.padSetInfo.settingContent.receiptRemark.isSelect=val;
                break;
            default:
                break;

        }
    }
    czchangeRadio(val, type) {
        if (!this.isEdit1) return;
        switch (type) {
            case 1:
                this.czpadSetInfo.settingContent.isPut = val;
                break;
            case 2:
                this.czpadSetInfo.settingContent.shopName.isSelect = val;
                if (val) {
                    this.czpadSetInfo.settingContent.shopName.value = this.shopInfo['shopName'];
                } else {
                    this.czpadSetInfo.settingContent.shopName.value = "";
                }
                break;
            case 3:
                this.czpadSetInfo.settingContent.member.isSelect = val;
                break;
            case 4:
                this.czpadSetInfo.settingContent.businessHours.isSelect = val;
                break;
            case 5:
                this.czpadSetInfo.settingContent.welcomeMessage.isSelect = val;
                break;
            case 6:
                this.czpadSetInfo.settingContent.shopInfo.isSelect = val;
                break;
            default:
                break;

        }
    }
    showTimePicker() {
        if (!this.isEdit1) return;
        let arr = this.padSetInfo.settingContent.businessHours.value ? this.padSetInfo.settingContent.businessHours.value.split('-') : [];
        if (arr.length > 0) {
            this.startTime = arr[0]
        }
        if (arr.length >= 1) {
            this.startTime = arr[0]
            this.endTime = arr[1]
        }
        this.dateShow = true;
    }
    czshowTimePicker() {
        if (!this.isEdit1 || !this.czpadSetInfo.settingContent.businessHours.isSelect) return;
        let arr = this.czpadSetInfo.settingContent.businessHours.value ? this.czpadSetInfo.settingContent.businessHours.value.split('-') : [];
        if (arr.length > 0) {
            this.czstartTime = arr[0]
        }
        if (arr.length >= 1) {
            this.czstartTime = arr[0]
            this.czendTime = arr[1]
        }
        this.dateShow = true;
    }
    onDateClose() {
        this.dateShow = false;
    }
    customTimefunc() {
        if (this.activeitem == 1) {
            this.padSetInfo.settingContent.businessHours.value = this.startTime + "-" + this.endTime;
        } else {
            this.czpadSetInfo.settingContent.businessHours.value = this.czstartTime + "-" + this.czendTime;
        }

        this.dateShow = false;
    }
    timeChange(event, index) {
        if (this.activeitem == 1) {
            if (index == 1) {
                this.startTime = event;
            } else {
                this.endTime = event;
            }
        } else {
            if (index == 1) {
                this.czstartTime = event;
            } else {
                this.czendTime = event;
            }
        }

    }
    choosePriceUnit(val) {
        if (!this.isEdit1) return;
        this.padSetInfo.settingContent.currency.value = val;
        this.showHbPopover = false;
    }
    czchoosePriceUnit(val) {
        if (!this.isEdit1) return;
        this.czpadSetInfo.settingContent.currency.value = val;
        this.showHbPopover = false;
    }
    cancelInfo() {
        this.isEdit1 = false;
        this.showHbPopover = false;
        this.init();
    }
    //编辑门店信息
    editInfo() {
        this.isEdit1 = true;
    }
    async saveEdit() {
        this.showHbPopover = false;

        //销售小票
        if (this.isLoading1) return;
        if (this.activeitem == 1) {
            this.isLoading1 = true;
            this.padSetInfo.settingContent.putNum = this.padSetInfo.settingContent.putNum ? this.padSetInfo.settingContent.putNum : 1;
            if (this.padSetInfo.settingContent.contactInfo) {
                this.padSetInfo.settingContent.contactInfo.index = 0;
            }
            try {
                this.padSetInfo.settingContent.contactInfo.value = this.concatName || this.concatPhone ? this.concatName + ":" + this.concatPhone : '';
                await TbSettingsPad.PutTbSettings({
                    id: this.padSetInfo.id,
                    settingContent: JSON.stringify(this.padSetInfo.settingContent),
                })
                await this.init();
                this.isLoading1 = false;
                this.isEdit1 = false;
                Toast('保存成功');
            } catch (error) {
                this.isLoading1 = false;
            }
        } else {
            this.isLoading1 = true;
            this.czpadSetInfo.settingContent.putNum = this.czpadSetInfo.settingContent.putNum ? this.czpadSetInfo.settingContent.putNum : 1;
            try {
                await TbSettingsPad.PutTbSettings({
                    id: this.czpadSetInfo.id,
                    settingContent: JSON.stringify(this.czpadSetInfo.settingContent),
                })
                await this.init();
                this.isLoading1 = false;
                this.isEdit1 = false;
                Toast('保存成功');
            } catch (error) {
                this.isLoading1 = false;
            }
        }
    }
    async printTest() {
        if (this.isPrintLoading) return;
        console.log('this.activeitem', this.activeitem);
        let address = localStorage.getItem('padShopInfo') ? JSON.parse(localStorage.getItem('padShopInfo')).address : ''
        if (this.activeitem == 1) {
            this.isPrintLoading = true;
            let resSetting = await TbSettingsPad.GetTbSettings({
                settingtype: 5,
            });
            let form = Object.assign({}, { settingContent: resSetting.settingContent }, { orderInfo: Object.assign({}, this.orderInfo, { address: address }) }, { type: 'receipt' });
            console.log('form', form);
            let time = 3000 * resSetting.settingContent.putNum
            if(form.settingContent.putNum>0){
                for(let i =1;i<=form.settingContent.putNum;i++){
                    setTimeout(()=>{
                        const canvas = this.$refs['barcodeCanvas'];
                        JsBarcode('canvas', form.orderInfo.orderNo, {
                            format: "CODE128", // 可以选择不同的格式，例如 CODE128, CODE39 等
                            lineColor: "#000",
                            width: 3,
                            height: 100,
                            displayValue: false
                        });
                        let barcodeImage = canvas.toDataURL("image/png"); // 转换为Base64编码的PNG图像
                        PrintEvent1(form,barcodeImage)
                    },3000)
                }
            }
            setTimeout(() => {
                this.isPrintLoading = false;
            }, time)

        } else {
            this.isPrintLoading = true;
            let resSetting = await TbSettingsPad.GetTbSettings({
                settingtype: 6,
            });
            let form = Object.assign({}, { settingContent: resSetting.settingContent }, { orderInfo: Object.assign({}, this.czorderInfo, { address: address }) }, { type: 'receipt', chargeFlag: '1' });
            console.log('充值打印1', form);
            let time = 3000 * resSetting.settingContent.putNum
            if(form.settingContent.putNum>0){
                for(let i =1;i<=form.settingContent.putNum;i++){
                    setTimeout(()=>{
                        PrintEvent2(form)
                    },3000)
                }
            }
            setTimeout(() => {
                this.isPrintLoading = false;
            }, time)
        }
    }
    goback(){
        this.$emit('changeTab',{tabActive:1,childActive:1})
    }
    
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/setting/components/xpInfo.vue